import { CalendarPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  buildMeetingCalendarEvent,
  downloadMeetingIcs,
} from "./meetingCalendarEvent";

export function AddToCalendarButton({
  title,
  start,
  end,
  url,
  className,
}: {
  title: string;
  start: string | Date;
  end?: string | Date | null;
  url?: string;
  className?: string;
}) {
  const event = buildMeetingCalendarEvent({ title, start, end, url });
  if (!event) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className={
            className ??
            "border-white/20 bg-white/5 text-white hover:bg-white/10 hover:text-white"
          }
        >
          <CalendarPlus />
          Add to Calendar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center">
        <DropdownMenuItem asChild>
          <a
            href={event.googleCalendarUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Calendar
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => downloadMeetingIcs({ title, start, end, url })}
        >
          Apple Calendar
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={event.outlookUrl} target="_blank" rel="noopener noreferrer">
            Outlook
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
